<div class="container p-0">
    <ca-form-field>
      <ca-label>{{'MENU.PUBLICO.MENU_USUARIO.MODAL_SUPLANTAR.BUSCAR' | translate}}</ca-label>
      <input 
        type="text" 
        minlength="1"
        caInput 
        placeholder="{{'MENU.PUBLICO.MENU_USUARIO.MODAL_SUPLANTAR.NOMBRE' | translate}}" 
        (input)="getUsuarioBuscar($event.target.value)" />
    </ca-form-field>
    <div class="d-flex justify-content-between mt-3">
      <button ca-button (click)="buscarUsuario(usuarioBuscar)">{{'MENU.PUBLICO.MENU_USUARIO.MODAL_SUPLANTAR.BUSCAR' | translate}}</button>
    </div>
    <div *ngIf="usuarioSuplantar$ | async as usuarioSuplantar">
      <br/>
      <h6>{{'MENU.PUBLICO.MENU_USUARIO.MODAL_SUPLANTAR.ENCONTRADO' | translate}}: 
        {{ usuarioSuplantar.nombre }} {{ usuarioSuplantar.apellidos }}
      </h6>
    </div>
    <div class="d-flex justify-content-between mt-3">
      <button ca-button-secondary (click)="closeDialog()">{{'MENU.PUBLICO.MENU_USUARIO.MODAL_SUPLANTAR.CANCELAR' | translate}}</button>
      <button ca-button (click)="suplantar()" [disabled]="!(usuarioSuplantar$ | async)">
        {{'MENU.PUBLICO.MENU_USUARIO.SUPLANTAR' | translate}}
      </button>
    </div>
</div>